// @ts-nocheck
import React, { useState } from 'react'
import ColorPickerModal from './ColorPickerModal'

const ProcessedModelStyleUpdate = ({dataSourceRecord, onChange}) => {
    const [colorPickerOpen, setColorPickerOpen] = useState(false);
    const [currentChannel, setCurrentChannel] = useState(null);
    const [currentVariation, setCurrentVariation] = useState(null);
    const [id] = Object.keys(dataSourceRecord)
    const record = dataSourceRecord[id]
    const {resource, renderProps} = record
    
    if (!renderProps || !renderProps.variations) {
        return (
            <div className="text-gray-500 text-center py-4">
                No parameters available for this model
            </div>
        );
    }
    
    const { variations } = renderProps

    // Function to toggle parameter visibility
    const toggleVisibility = (channel, variationKey) => {
        const updatedRenderProps = structuredClone(renderProps)
        updatedRenderProps.variations[variationKey][channel].visible = 
            !updatedRenderProps.variations[variationKey][channel].visible

        onChange({
            [id]: {
                ...record,
                renderProps: updatedRenderProps
            }
        })
    }
    
    // Function to open color picker for a specific channel
    const openColorPicker = (channel, variationKey) => {
        setCurrentChannel(channel);
        setCurrentVariation(variationKey);
        setColorPickerOpen(true);
    }
    
    // Function to handle color selection
    const handleColorSelect = (color) => {
        if (currentChannel && currentVariation) {
            const updatedRenderProps = structuredClone(renderProps);
            updatedRenderProps.variations[currentVariation][currentChannel].color = color;
            
            onChange({
                [id]: {
                    ...record,
                    renderProps: updatedRenderProps
                }
            });
        }
    }

    // Format variation key for display (Example: "wind_speed" => "Wind Speed")
    const formatVariationName = (key) => {
        return key.split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

    // Function to toggle all parameters in a variation
    const toggleAllInVariation = (variationKey, setTo) => {
        const updatedRenderProps = structuredClone(renderProps);
        
        // Loop through all channels in this variation and set their visibility
        Object.keys(updatedRenderProps.variations[variationKey]).forEach(channel => {
            updatedRenderProps.variations[variationKey][channel].visible = setTo;
        });
        
        onChange({
            [id]: {
                ...record,
                renderProps: updatedRenderProps
            }
        });
    };
    
    // Function to check if all parameters in a variation are visible
    const areAllVisible = (renderData) => {
        return Object.values(renderData).every(item => item.visible);
    };
    
    // Function to check if none of the parameters in a variation are visible
    const areNoneVisible = (renderData) => {
        return Object.values(renderData).every(item => !item.visible);
    };

    // Function to render parameter buttons for a variation
    const renderParameterButtons = (variationKey, renderData) => {
        return (
            <div className="grid grid-cols-3 gap-1 mt-1 mb-2">
                {Object.entries(renderData).map(([channel, channelRender], index) => (
                    <button
                        key={`${variationKey}-${channel}-${index}`}
                        onClick={() => toggleVisibility(channel, variationKey)}
                        className={`px-2 py-1 border text-xs text-left rounded-md transition-colors ${
                            channelRender.visible
                                ? 'bg-blue-50 border-blue-500 font-medium text-blue-700'
                                : 'bg-gray-50 border-gray-300 text-gray-500 hover:bg-gray-100'
                        }`}
                    >
                        <div className="flex items-center justify-between">
                            <span>{channel}</span>
                            <button 
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevent toggling visibility
                                    openColorPicker(channel, variationKey);
                                }}
                                className="rounded-full w-5 h-5 flex items-center justify-center border border-gray-300 hover:border-gray-500 focus:outline-none cursor-pointer transition-all"
                                style={{ 
                                    backgroundColor: channelRender.visible ? channelRender.color : '#e5e7eb'
                                }}
                                title="Change color"
                            >
                            </button>
                        </div>
                    </button>
                ))}
            </div>
        );
    }

    return (
        <div>
            <div className="space-y-2">
                {Object.entries(variations).map(([variationKey, renderData], index) => (
                    <div key={`variation-${variationKey}-${index}`} className="border border-gray-200 rounded-md p-2 bg-white">
                        <div className="flex justify-between items-center pb-1 border-b mb-1">
                            <div className="font-medium text-sm text-gray-700">
                                {formatVariationName(variationKey)}
                            </div>
                            <div className="flex space-x-1">
                                <button 
                                    onClick={() => toggleAllInVariation(variationKey, true)}
                                    className={`text-xs px-2 py-0.5 rounded-md ${
                                        areAllVisible(renderData) 
                                            ? 'bg-blue-100 text-blue-700 font-medium' 
                                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                    }`}
                                >
                                    All
                                </button>
                                <button 
                                    onClick={() => toggleAllInVariation(variationKey, false)}
                                    className={`text-xs px-2 py-0.5 rounded-md ${
                                        areNoneVisible(renderData) 
                                            ? 'bg-blue-100 text-blue-700 font-medium' 
                                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                    }`}
                                >
                                    None
                                </button>
                            </div>
                        </div>
                        {renderParameterButtons(variationKey, renderData)}
                    </div>
                ))}
            </div>
            
            {/* Color Picker Modal */}
            {currentChannel && currentVariation && (
                <ColorPickerModal
                    isOpen={colorPickerOpen}
                    onClose={() => setColorPickerOpen(false)}
                    initialColor={renderProps.variations[currentVariation][currentChannel].color}
                    onColorSelect={handleColorSelect}
                />
            )}
        </div>
    )
}

export default ProcessedModelStyleUpdate